import React, { useState, useEffect } from 'react';
import { TrendingUp, DollarSign } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

export default function RevenuePage() {
  const { api } = useAuth();
  const [data, setData] = useState(null);

  useEffect(() => { api('get', '/api/admin/revenue').then(r => setData(r.data)).catch(console.error); }, []);

  return (
    <div className="max-w-4xl">
      <h1 className="text-2xl font-bold text-white mb-6">Omzet Overzicht</h1>
      {!data ? (
        <div className="flex justify-center py-12"><div className="w-8 h-8 border-2 border-[#D4A017] border-t-transparent rounded-full animate-spin" /></div>
      ) : (
        <div className="space-y-6">
          <div className="grid sm:grid-cols-2 gap-4">
            <div className="bg-[#0f172a] rounded-2xl border border-[#D4A017]/20 p-6">
              <DollarSign className="w-8 h-8 text-[#D4A017] mb-3" />
              <p className="text-[#64748b] text-sm uppercase tracking-wider mb-1">Maandelijkse Omzet (MRR)</p>
              <p className="text-white font-bold text-3xl">€{data.total_mrr?.toLocaleString('nl-NL')}</p>
            </div>
            <div className="bg-[#0f172a] rounded-2xl border border-white/5 p-6">
              <TrendingUp className="w-8 h-8 text-green-400 mb-3" />
              <p className="text-[#64748b] text-sm uppercase tracking-wider mb-1">Actieve Contracten</p>
              <p className="text-white font-bold text-3xl">{data.active_contracts}</p>
            </div>
          </div>
          <div className="bg-[#0f172a] rounded-2xl border border-white/5 p-6">
            <h3 className="text-white font-bold mb-4">Omzet per dienst</h3>
            <div className="space-y-3">
              {Object.entries(data.by_service || {}).sort((a, b) => b[1] - a[1]).map(([svc, amount]) => {
                const pct = data.total_mrr > 0 ? Math.round((amount / data.total_mrr) * 100) : 0;
                return (
                  <div key={svc}>
                    <div className="flex justify-between mb-1">
                      <span className="text-[#94a3b8] text-sm">{svc}</span>
                      <span className="text-white font-bold text-sm">€{amount.toLocaleString('nl-NL')}/mnd</span>
                    </div>
                    <div className="h-1.5 bg-white/10 rounded-full">
                      <div className="h-full bg-[#D4A017] rounded-full" style={{ width: `${pct}%` }} />
                    </div>
                  </div>
                );
              })}
              {!Object.keys(data.by_service || {}).length && <p className="text-[#475569] text-sm">Geen actieve contracten</p>}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
